<template>
  <div class="modal-container-height">

  </div>
</template>

<script>
import SCWalkThroughModal from "./SCWalkThroughModal";

export default {
  name: "SCWalkThroughModalContainer",
  created() {
    this.launchWalkThroughModal()
  },
  beforeDestroy() {
    this.$modal.hide('SCWalkThroughModal')
    document.documentElement.style.overflow = "auto";
  },
  methods: {
    launchWalkThroughModal() {
      document.documentElement.style.overflow = "hidden";
      this.$modal.show(
          SCWalkThroughModal,
          {},
          {
            name: 'SCWalkThroughModal',
            width: 1200,
            adaptive: true,
            height : "auto",
            scrollable: true,
            clickToClose: false
          },{
            onClosed: () => {
              if (this.$route.params && this.$route.params.currentRoute){
                /* eslint-disable no-console */
                this.$router.push({name: this.$route.params.currentRoute}).catch((ex) => { if(ex.name !== 'NavigationDuplicated') { console.error(ex) }});
              }else{
                this.$router.push("/").then(() => {});
              }
            },
          })
    },
  }
}
</script>

<style scoped>
.modal-container-height {
  height: 100vh;
}
</style>